<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Opsi Revisi</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              <a href="#">Pengaturan Aplikasi</a>
            </div>
            <div class="breadcrumb-item">
              Opsi Revisi
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="row">
            <div class="col-lg-4 my-2">
              <div class="list-group">
                <router-link
                  to="/setting/opsi-revisi"
                  class="list-group-item list-group-item-action"
                >
                  Opsi Revisi
                </router-link>
                <router-link
                  to="/home"
                  class="list-group-item list-group-item-action"
                >
                  Setting 2
                </router-link>
                <router-link
                  to="/home"
                  class="list-group-item list-group-item-action"
                >
                  Setting 3
                </router-link>
              </div>
            </div>
            <div class="col-lg-8 my-2">
              <div class="card card-primary">
                <div class="card-header">
                  <h4>Opsi Revisi</h4>
                </div>
                <div class="card-body">
                  <div class="alert alert-primary alert-has-icon">
                    <div class="alert-icon">
                      <i class="far fa-lightbulb" />
                    </div>
                    <div class="alert-body">
                      <div class="alert-title">
                        Informasi
                      </div>
                      Opsi Revisi adalah pengaturan untuk mengarahkan revisi permohonan apakah berulang secara berjenjang,
                      mulai dari jenjang yang dipilih pemberi revisi, atau langsung ke pemberi revisi.
                    </div>
                  </div>

                  <div class="form-group row">
                    <label
                      for=""
                      class="col-form-label col-md-4 text-md-right text-left"
                    >Opsi Revisi</label>
                    <div class="col-md-4">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="orUlang"
                          name="opsi_revisi"
                          class="custom-control-input"
                          value="1"
                          v-model="form.opsi_revisi"
                        >
                        <label
                          class="custom-control-label"
                          for="orUlang"
                        >Ulang Dari Awal</label>
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="orDinamis"
                          name="opsi_revisi"
                          class="custom-control-input"
                          value="2"
                          v-model="form.opsi_revisi"
                        >
                        <label
                          class="custom-control-label"
                          for="orDinamis"
                        >Dapat Dipilih Pemberi Revisi</label>
                      </div>
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="orLangsung"
                          name="opsi_revisi"
                          class="custom-control-input"
                          value="3"
                          v-model="form.opsi_revisi"
                        >
                        <label
                          class="custom-control-label"
                          for="orLangsung"
                        >Langsung ke Pemberi Revisi</label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-md-4 offset-md-4">
                      <button class="btn btn-primary">
                        <i class="fa fa-check mr-2" />Simpan
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<style scoped>

</style>

<script>
import LayoutAdmin from './../layouts/Admin.vue'


export default {
	name: 'App',
	data(){
	return {
		form: {
			opsi_revisi: null
		}
	}
	},
	computed: {
		profile(){
			return this.$store.getters.getUserProfile
		}
	},
	components: {
		LayoutAdmin
	},
	methods: {
		
	}
}
</script>

<style>

</style>
